import { classNames } from "utils/ClassNames"
import { UniqueGradient } from "./UniqueGradient"

interface Entry {
  id: string
  title: string
  text: string
  timestamp: string
}

interface SimpleEntry extends Entry {
  type: "simple"
}

interface TextBoxEntry extends Entry {
  type: "text-box"
  avatarUrl?: string
  subtitle?: string
}

export const TimelineComponent = ({
  entries
}: {
  entries: Array<SimpleEntry | TextBoxEntry>
}) => {
  return (
    <ul role="list" className="space-y-6">
      {entries.map((entry, index) => (
        <li key={entry.id} className="relative flex gap-x-4">
          <div
            className={classNames(
              index === entries.length - 1 ? "h-6" : "-bottom-6",
              "absolute left-0 top-0 flex w-6 justify-center"
            )}
          >
            <div className="w-px bg-gray-200" />
          </div>
          {entry.type === "text-box" ? (
            <>
              {entry.avatarUrl ? (
                <img
                  src={entry.avatarUrl}
                  className="relative mt-3 h-6 w-6 flex-none rounded-full bg-gray-50"
                />
              ) : (
                <UniqueGradient
                  id={entry.id}
                  className="relative mt-3 h-6 w-6 flex-none rounded-full bg-gray-50"
                />
              )}
              <div className="flex-auto rounded-md p-3 ring-1 ring-inset ring-gray-200">
                <div className="flex justify-between lg:items-center gap-x-4">
                  <div className="py-0.5 text-xs/5 text-gray-500">
                    <p className="flex-auto py-0.5 text-xs/5 text-gray-500">
                      <span className="font-medium text-xs text-gray-900">
                        {entry.title}
                      </span>{" "}
                      {entry.subtitle}
                    </p>
                  </div>
                  <time
                    dateTime={entry.timestamp}
                    className="flex-none py-0.5 text-xs/5 text-gray-500"
                  >
                    {entry.timestamp}
                  </time>
                </div>
                <p className="text-sm/6 text-gray-500">{entry.text}</p>
              </div>
            </>
          ) : (
            <>
              <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" />
              </div>
              <p className="flex-auto py-0.5 text-xs/5 text-gray-500">
                <span className="font-medium text-gray-900">{entry.title}</span>{" "}
                {entry.text}
              </p>
              <time
                dateTime={entry.timestamp}
                className="flex-none py-0.5 text-xs/5 text-gray-500"
              >
                {entry.timestamp}
              </time>
            </>
          )}
        </li>
      ))}
    </ul>
  )
}
